import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import PaymentsService from '@/services/PaymentService';
import { trackPaymentResult } from '@/utils/analytics';

export default function PaymentResult() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const status = params.get('payment_status');
  const paymentId = params.get('payment_id');

  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPayment() {
      if (!paymentId) {
        setLoading(false);
        return;
      }
      try {
        const res = await PaymentsService.getPaymentById(paymentId);
        setPayment(res.data);
        trackPaymentResult(status, res.data?.charge, paymentId);
      } catch (e) {
        // ignore
        trackPaymentResult(status, 0, paymentId);
      } finally {
        setLoading(false);
      }
    }
    fetchPayment();
  }, [paymentId, status]);

  return (
    <main className='mx-auto max-w-3xl px-4 py-8'>
      <h1 className='mb-4 text-2xl font-semibold'>Potvrda o plaćanju</h1>
      {loading ? (
        <p>Učitavanje...</p>
      ) : (
        <div className='space-y-4'>
          <div
            className={`rounded-md border px-4 py-3 ${status === 'success' ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'}`}
          >
            <p className='font-medium'>
              {status === 'success'
                ? 'Uspešno ste izvršili plaćanje – račun Vaše platne kartice je zadužen.'
                : 'Plaćanje neuspešno – račun Vaše platne kartice nije zadužen.'}
            </p>
          </div>

          {payment && (
            <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
              <section>
                <h2 className='mb-2 text-lg font-semibold'>Podaci o korisniku</h2>
                <ul className='text-sm'>
                  <li>Ime i prezime: {payment.userFullName || '—'}</li>
                  <li>Email: {payment.userEmail || '—'}</li>
                </ul>
              </section>

              <section>
                <h2 className='mb-2 text-lg font-semibold'>Podaci o trgovcu</h2>
                <ul className='text-sm'>
                  <li>Naziv: {import.meta.env.VITE_MERCHANT_NAME || 'RentaSvet'}</li>
                  <li>PIB: {import.meta.env.VITE_MERCHANT_PIB || '—'}</li>
                  <li>Adresa: {import.meta.env.VITE_MERCHANT_ADDRESS || '—'}</li>
                </ul>
              </section>

              <section>
                <h2 className='mb-2 text-lg font-semibold'>Podaci o narudžbini</h2>
                <ul className='text-sm'>
                  <li>Order ID: {payment._id}</li>
                  <li>
                    Iznos: {payment.charge} {import.meta.env.VITE_CURRENCY || 'RSD'}
                  </li>
                </ul>
              </section>

              <section>
                <h2 className='mb-2 text-lg font-semibold'>Podaci o transakciji</h2>
                <ul className='text-sm'>
                  <li>AuthCode: {payment.authCode || '—'}</li>
                  <li>TransId: {payment.transId || '—'}</li>
                  <li>Response: {payment.responseText || '—'}</li>
                  <li>ProcReturnCode: {payment.procReturnCode || '—'}</li>
                  <li>mdStatus: {payment.mdStatus || '—'}</li>
                  <li>EXTRA.TRXDATE: {payment.extraTrxDate || '—'}</li>
                  <li>MaskedPan: {payment.maskedPan || '—'}</li>
                </ul>
              </section>
            </div>
          )}

          <div className='pt-4'>
            <Link className='text-primary-yellow underline' to='/dashboard/payments'>
              Nazad na plaćanja
            </Link>
          </div>
        </div>
      )}
    </main>
  );
}
